import React, { useState } from "react";
import Popup from "../Popup/BasePopup";
import TournamentBox from '../Tournament/TournamentBox/TournamentBox'


const JoinViaInviteCodePopup = ({ isOpen, title, onClose }) => {

  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose}>
      <TournamentBox />
      </Popup>
  );
};

export default JoinViaInviteCodePopup;
